import React from 'react';
import { NodeProps, useEdges, useNodes } from 'reactflow';
import { Main, Styled } from './style';
import { SettingsBlock, settingsDataType } from '../../../../settingsBlock';
import { IoCheckmarkCircleOutline, IoWarningOutline } from 'react-icons/io5';
import { ExpandedBlock } from '../../../expanded';
import { operationType } from '../../../../../services/types';

type EditFieldsProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function MergeBlock({ id, data, setChildMinimize, setChildSettings }: EditFieldsProps) {
   const nodes = useNodes();
   const edges = useEdges();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // --- 
   const filter = nodes.filter(node => edges.some(edge => edge.target === id && node.id === edge.source));
   const isWarning = false;
   
   return (<>
      <SettingsBlock nodeId={ id } data={ settings } setData={ setSettings } />
      <Main>
         { isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={ 21 } /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={ 21 } /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ minWidth: '350px' }}
         ><Styled>
            { filter.length ? <>
               <h3>Blocks Connected <span>(Merge Outputs)</span></h3>
               { filter.map(item => (
                  <div key={ item.id }>
                     <span></span>
                     <span>{ // @ts-ignore
                        item.data?.index 
                     }</span> 
                  </div>
               ))}
            </> : <span className="empty">No blocks connected</span> }
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}